// IndustriesRow.jsx
// Horizontally scrollable pill strip of industries served.

const industries = [
  "Construction",
  "Transportation",
  "Retail",
  "Tech Startups",
  "Healthcare",
  "Manufacturing",
  "Real Estate",
  "E-commerce",
  "Agriculture",
  "Professional Services",
];

function IndustryPill({ label }) {
  return (
    <span className="px-6 py-2 bg-white/70 backdrop-blur-md border border-navy/5 rounded-full whitespace-nowrap font-manrope font-semibold text-[13px] text-navy hover:bg-gold/10 hover:border-gold/30 hover:text-gold transition-all cursor-default">
      {label}
    </span>
  );
}

export default function IndustriesRow() {
  return (
    <section className="py-10 bg-surface-container-low border-y border-outline-variant/30 overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="flex items-center gap-8 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <span className="font-manrope text-label-caps text-on-surface-variant whitespace-nowrap opacity-50 flex-shrink-0">
            INDUSTRIES WE SERVE:
          </span>
          <div className="flex gap-3 flex-shrink-0">
            {industries.map((industry) => (
              <IndustryPill key={industry} label={industry} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
